module.exports = __webpack_public_path__ + "img/2.58cf6c7f.png";